var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEquipmentManagementActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.5 14.625C1.5 13.7415 1.5 13.299 1.83 13.0245C2.1585 12.75 2.68875 12.75 3.75 12.75C4.81125 12.75 5.34075 12.75 5.67 13.0245C5.99925 13.299 6 13.7415 6 14.625C6 15.5085 6 15.951 5.67 16.2255C5.3415 16.5 4.81125 16.5 3.75 16.5C2.68875 16.5 2.15925 16.5 1.83 16.2255C1.50075 15.951 1.5 15.5085 1.5 14.625ZM12 14.625C12 13.7415 12 13.299 12.33 13.0245C12.6585 12.75 13.1888 12.75 14.25 12.75C15.3112 12.75 15.8407 12.75 16.17 13.0245C16.4992 13.299 16.5 13.7415 16.5 14.625C16.5 15.5085 16.5 15.951 16.17 16.2255C15.8415 16.5 15.3112 16.5 14.25 16.5C13.1888 16.5 12.6593 16.5 12.33 16.2255C12.0008 15.951 12 15.5085 12 14.625Z",
    stroke: "#5921F2",
    strokeWidth: 1.13
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.25 12.75C14.25 10.8885 13.692 10.5 11.019 10.5H6.981C4.308 10.5 3.75 10.8885 3.75 12.75",
    stroke: "#5921F2",
    strokeWidth: 1.13,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9 4.875L9.75 3.75M12.375 4.875C12.375 5.77011 12.0194 6.62855 11.3865 7.26149C10.7535 7.89442 9.89511 8.25 9 8.25C8.10489 8.25 7.24645 7.89442 6.61351 7.26149C5.98058 6.62855 5.625 5.77011 5.625 4.875C5.625 3.97989 5.98058 3.12145 6.61351 2.48851C7.24645 1.85558 8.10489 1.5 9 1.5C9.89511 1.5 10.7535 1.85558 11.3865 2.48851C12.0194 3.12145 12.375 3.97989 12.375 4.875Z",
    stroke: "#5921F2",
    strokeWidth: 1.13,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEquipmentManagementActive);
export default __webpack_public_path__ + "static/media/EquipmentManagementActive.e46938d010ea51ba31b2ebf9578a24e7.svg";
export { ForwardRef as ReactComponent };